module.exports = __webpack_public_path__ + "img/Aliya3.75032bdc.jpg";